import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationService } from 'app/auth/service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-kuber-ai',
  templateUrl: './kuber-ai.component.html',
  styleUrls: ['./kuber-ai.component.scss']
})
export class KuberAiComponent implements OnInit, OnDestroy {
  iframeSrc: SafeResourceUrl;
  messageLog: string[] = [];
  private tokenSub: any;
  private kuberAiUrl = environment.kuberAiUrl;
  private iframeReady = false;
  private pendingToken: string | null = null;

  constructor(
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private afAuth: AngularFireAuth
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadIframe();

    // Automatically send fresh token to iframe whenever Firebase refreshes it.
    // If the iframe isn't loaded yet, queue the latest token and flush on (load).
    // Avoids the origin-mismatch error during the brief about:blank phase.
    this.tokenSub = this.afAuth.idToken.subscribe((token) => {
      if (!token) return;
      if (this.iframeReady) {
        this.postTokenToIframe(token);
      } else {
        this.pendingToken = token;
      }
    });

    window.addEventListener('message', (event) => {
      if (event.origin !== this.kuberAiUrl) return;
      if (event.data?.type === 'REQUEST_TOKEN_REFRESH') {
        this.afAuth.currentUser.then(user => user?.getIdToken(true));
        return;
      }
      this.messageLog.push(JSON.stringify(event.data));
    });
  }

  private async loadIframe(): Promise<void> {
    const user = this.authService.currentUserValue;
    const firebaseUser = await this.afAuth.currentUser;
    const freshToken = firebaseUser ? await firebaseUser.getIdToken(true) : user?.token;
    const url = `${this.kuberAiUrl}?userId=${user?.id}&role=${user?.role}&token=${freshToken}&tenantId=${user?.tenantId}`;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onIframeLoaded(): void {
    this.iframeReady = true;
    if (this.pendingToken) {
      this.postTokenToIframe(this.pendingToken);
      this.pendingToken = null;
    }
  }

  private postTokenToIframe(token: string): void {
    const iframe = document.querySelector('iframe');
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage(
        { type: 'TOKEN_REFRESH', token },
        this.kuberAiUrl
      );
    }
  }

  ngOnDestroy(): void {
    if (this.tokenSub) this.tokenSub.unsubscribe();
  }
}
